import { ref } from "vue";

export const access_token = ref<string | null>(localStorage.getItem('access_token'))